import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { observer } from 'mobx-react';
import ListButton from '../../../components/ListButton';
import Icon from '../../../components/Icon';
var AddPayoutMethodButton = function AddPayoutMethodButton(props) {
  return /*#__PURE__*/React.createElement(ListButton, _extends({
    icon: /*#__PURE__*/React.createElement(Icon, {
      auto: true,
      material: true,
      name: "add"
    })
  }, props), "Add Payout Method");
};
export default observer(AddPayoutMethodButton);
//# sourceMappingURL=index.js.map
